import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

export const surveyService = {
    getSurvey: __getSurvey,
    getSectionMetadata: __getSectionMetadata,
    getQuestionStatuses: __getQuestionStatuses,
    updateSurveyStatus: __updateSurveyStatus,
    updateMandatoryQuestionsAnswered: __updateMandatoryQuestionsAnswered,
    getSurveyType: __getSurveyType,
    lockSurvey: __lockSurvey,
    getLockStatus: __getLockStatus,
    setCurrentUser: __setCurrentUser,
    setAggregate: __setAggregate,
    getAggregationHistory: __getAggregationHistory,
    setSurveyLockStatus: __setSurveyLockStatus,
    savesubOffice: __savesubOffice,
    saveNewAgencyWithNewOffice: __saveNewAgencyWithNewOffice,
    getOfficeInfo: __getOfficeInfo,
    makeUseOfAvaiableOffice: __makeUseOfAvaiableOffice,
    getExcelDownload: __getExcelDownload,
    getCountryInfo: _getCountryInfo,
    saveAnswerCountries: __saveAnswerCountries,
    saveCountries: __saveCountries,
    saveOrganization: __saveOrganization,
    getSurveyId: __getSurveyId,
    deleteOffice: __deleteOffice,
    getOrganization: __getOrganization
};

async function __getSurvey (surveyId) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}`);
        const headers = utilityService.getHeaders();
        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to load survey:", error);
        throw error; // rethrow so callers can handle it
    }
}

async function __getSurveyId (volume, username) {
    try {
        const url = utilityService.getApiUrl(`survey/${volume}/getsurveyId/${username}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to load surveyId:", error);
        throw error;
    }
}

async function __getSectionMetadata (surveyId, sectionId) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/section/${sectionId}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to load section metadata:", error);
        throw error;
    }
}

async function __getQuestionStatuses (surveyId) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/surveyStatus`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to load question statuses:", error);
        throw error;
    }
}

async function __updateSurveyStatus (surveyId, surveyStatus) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/status`);
        const headers = utilityService.getHeaders();

        const response = await axios.put(url, surveyStatus, { headers });
        return response;
    } catch (error) {
        console.error("Failed to update survey status:", error);
        throw error;
    }
}

async function __updateMandatoryQuestionsAnswered (surveyId, flag) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/mandatoryQuestionsAnswered`);
        const headers = utilityService.getHeaders();

        const response = await axios.put(url, flag, { headers });
        return response;
    } catch (error) {
        console.error("Failed to update mandatory questions flag:", error);
        throw error;
    }
}

async function __getSurveyType (surveyId) {
    try {
        const url = utilityService.getApiUrl(`survey/type/${surveyId}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to get survey type:", error);
        throw error;
    }
}

async function __lockSurvey (surveyId, bLock) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/lockorunlocksurvey/${bLock}`);
        const headers = utilityService.getHeaders();

        const response = await axios.post(url, null, { headers });
        return response;
    } catch (error) {
        console.error("Failed to lock/unlock survey:", error);
        throw error;
    }
}

async function __setSurveyLockStatus (surveyId, lock) {
    try {
        const url = utilityService.getApiUrl(`survey/surveyrootstatus`);
        const headers = utilityService.getHeaders();

        const payload = { SurveyId: surveyId, LockUnLock: lock };

        const response = await axios.post(url, payload, { headers });
        return response;
    } catch (error) {
        console.error("Failed to set survey lock status:", error);
        throw error;
    }
}

async function __deleteOffice (surveyId, officeId) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/officeId/${officeId}`);
        const headers = utilityService.getHeaders();

        const response = await axios.delete(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to delete office:", error);
        throw error;
    }
}

async function __getLockStatus (surveyId) {
    try {
        const url = utilityService.getApiUrl(`survey/lock-status/${surveyId}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to get lock status:", error);
        throw error;
    }
}

async function __setCurrentUser (surveyId, isCurrent) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/current/${isCurrent}`);
        const headers = utilityService.getHeaders();

        const response = await axios.put(url, null, { headers });
        return response;
    } catch (error) {
        console.error("Failed to set current user:", error);
        throw error;
    }
}

async function __setAggregate (surveyId, aggregateType) {
    try {
        const url = utilityService.getApiUrl('survey/aggregate');
        const headers = utilityService.getHeaders();

        const payload = { SurveyId: surveyId, SumAll: aggregateType };

        const response = await axios.post(url, payload, { headers });
        console.log(response);
        return response;
    } catch (error) {
        if (!error.response) {
            console.error("Network error");
        } else {
            console.error("Error:", error.response.data.message);
        }
        throw error;
    }
}

async function __getAggregationHistory (surveyId) {
    try {
        const url = utilityService.getApiUrl(`survey/aggregatehistory/${surveyId}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to load aggregation history:", error);
        throw error;
    }
}

async function __savesubOffice (
    surveyId, selectDeptment, officeName, officeAbbreviation, description,
    firstName, lastName, emailId, title,
    supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle,
    userId, currentVolume, addnewFlag
) {
    try {
        const url = utilityService.getApiUrl('survey/savesubOffice/');
        const headers = utilityService.getHeaders();

        const payload = {
            SurveyId: surveyId,
            DepartmentId: selectDeptment,
            OfficeName: officeName,
            OfficeAbbreviation: officeAbbreviation,
            Description: description,
            FirstName: firstName,
            LastName: lastName,
            EmailId: emailId,
            Title: title,
            SupervisorfirstName: supervisorfirstName,
            SupervisorlastName: supervisorlastName,
            SupervisoremailId: supervisoremailId,
            SupervisorTitle: supervisorTitle,
            UserId: userId,
            Volume: currentVolume,
            AddnewFlag: addnewFlag
        };

        const response = await axios.post(url, payload, { headers });
        return response;
    } catch (error) {
        console.error("Failed to save sub office:", error);
        throw error;
    }
}

async function __saveNewAgencyWithNewOffice (
    selectSurveyType, agency, surveyId, selectDeptment, officeName,
    officeAbbreviation, description, firstName, lastName, emailId, title,
    supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle,
    addnewFlag
) {
    try {
        const url = utilityService.getApiUrl('survey/saveNewAgencyWithNewOffice/');
        const headers = utilityService.getHeaders();

        const payload = {
            SurveyType: selectSurveyType,
            Agency: agency,
            SurveyId: surveyId,
            DepartmentId: selectDeptment,
            OfficeName: officeName,
            OfficeAbbreviation: officeAbbreviation,
            Description: description,
            FirstName: firstName,
            LastName: lastName,
            EmailId: emailId,
            Title: title,
            SupervisorfirstName: supervisorfirstName,
            SupervisorlastName: supervisorlastName,
            SupervisoremailId: supervisoremailId,
            SupervisorTitle: supervisorTitle,
            AddnewFlag: addnewFlag
        };

        const response = await axios.post(url, payload, { headers });
        return response;
    } catch (error) {
        console.error("Failed to save new agency with new office:", error);
        throw error;
    }
}

async function __saveAnswerCountries (surveyId, countryId, con, pla, tot, vqId) {
    try {
        const url = utilityService.getApiUrl('survey/saveAnswerCountries/');
        const headers = utilityService.getHeaders();

        const payload = {
            SurveyId: surveyId,
            CountryId: countryId,
            Con: con,
            Pla: pla,
            Tot: tot,
            QId: vqId
        };

        const response = await axios.post(url, payload, { headers });
        return response;
    } catch (error) {
        console.error("Failed to save answer countries:", error);
        throw error;
    }
}

async function __getOfficeInfo (officename) {
    try {
        const url = utilityService.getApiUrl(`survey/getOffice/${officename}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to get office info:", error);
        throw error;
    }
}

async function __makeUseOfAvaiableOffice (participatingOfficesList) {
    try {
        const url = utilityService.getApiUrl(`survey/makeUseofOffices/`);
        const headers = utilityService.getHeaders();

        const payload = { ParticipatingOfficesList: participatingOfficesList };

        const response = await axios.post(url, payload, { headers });
        return response;
    } catch (error) {
        console.error("Failed to make use of available office:", error);
        throw error;
    }
}

async function __getExcelDownload (surveyId, isEmpty) {
    try {
        const url = utilityService.getApiUrl(`survey/${surveyId}/excel/${isEmpty}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, {
            responseType: 'blob',
            headers
        });

        return response;
    } catch (error) {
        console.error("Failed to download Excel:", error);
        throw error;
    }
}

async function _getCountryInfo (countryname, surveyId, vqId) {
    try {
        const url = utilityService.getApiUrl(
            `survey/getCountryInfo/${countryname}/surveyId/${surveyId}/qId/${vqId}`
        );
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;
    } catch (error) {
        console.error("Failed to get country info:", error);
        throw error;
    }
}

async function __saveCountries (surveyId, selectedCountries, userName, vqId) {
    try {
        const url = utilityService.getApiUrl('survey/saveCountries/');
        const headers = utilityService.getHeaders();

        const payload = {
            SurveyId: surveyId,
            SelectedCountries: selectedCountries,
            UserName: userName,
            QId: vqId
        };

        const response = await axios.post(url, payload, { headers });
        return response;
    } catch (error) {
        console.error("Failed to save countries:", error);
        throw error;
    }
}

async function __saveOrganization (
    isActive, organizationFice, organizationPFice, organizationName, organizationShortName,
    organizationType, address, city, state, zip, phone, hbcu, hdg, nptype, toc, instLvl,
    campusseq, carncode, hhe, tribal, minority, system, sysflag, webAddress, comments,
    dstSorterName, dstName, unitId, version, styleGuideReviewCompleted,
    styleGuideReviewCompletedDate, haie, cleanupcode, lastFyFunded, closed, ein, flag
) {
    try {
        const url = utilityService.getApiUrl('survey/saveOrganization/');
        const headers = utilityService.getHeaders();

        const payload = {
            IsActive: isActive,
            OrganizationFice: organizationFice,
            OrganizationPFice: organizationPFice,
            OrganizationName: organizationName,
            OrganizationShortName: organizationShortName,
            OrganizationTypeCode: organizationType,
            Address: address,
            City: city,
            State: state,
            Zip: zip,
            Phone: phone,
            Hbcu: hbcu,
            Hdg: hdg,
            Nptype: nptype,
            Toc: toc,
            InstLvl: instLvl,
            Campusseq: campusseq,
            CarnCode: carncode,
            Hhe: hhe,
            Tribal: tribal,
            Minority: minority,
            SysFlag: sysflag,
            System: system,
            WebAddress: webAddress,
            Comments: comments,
            DstSorterName: dstSorterName,
            DstName: dstName,
            UnitId: unitId,
            Version: version,
            StyleGuideReviewCompleted: styleGuideReviewCompleted,
            StyleGuideReviewCompletedDate: styleGuideReviewCompletedDate,
            Haie: haie,
            Cleanupcode: cleanupcode,
            LastFyFunded: lastFyFunded,
            Closed: closed,
            EIN: ein,
            Flag: flag
        };

        const response = await axios.post(url, payload, { headers });
        return response;

    } catch (error) {
        console.error("Failed to save organization:", error);
        throw error;
    }
}

async function __getOrganization (orgname) {
    try {
        const url = utilityService.getApiUrl(`survey/getOrganization/${orgname}`);
        const headers = utilityService.getHeaders();

        const response = await axios.get(url, { headers });
        return response;

    } catch (error) {
        console.error("Failed to get organization:", error);
        throw error;
    }
}
